import { MapPin, Phone } from "lucide-react";
import { ABOUT_IMAGE, ZONES, ABOUT, COMPANY } from "../lib/data";
import Reveal from "./Reveal";

export default function About() {
  return (
    <section id="a-propos" data-testid="about-section" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <Reveal>
          <div className="relative">
            <div className="rounded-[1.75rem] overflow-hidden border border-slate-200 shadow-xl shadow-slate-200/60 aspect-[4/3]">
              <img
                src={ABOUT_IMAGE}
                alt="Le camion et l'artisan Le Bon Dépanneur prêts à intervenir"
                loading="lazy"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute -bottom-5 -right-3 sm:right-6 bg-white rounded-2xl shadow-xl shadow-slate-300/40 border border-slate-100 px-5 py-4">
              <p className="font-display font-extrabold text-2xl gradient-text">+10 ans</p>
              <p className="text-xs text-ink-soft mt-1">au service des Franciliens</p>
            </div>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <span className="overline">{ABOUT.overline}</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-3 font-display font-extrabold text-ink text-3xl md:text-5xl leading-tight">
              {ABOUT.title}
            </h2>
          </Reveal>
          {ABOUT.paragraphs.map((p, i) => (
            <Reveal key={i} delay={0.15 + i * 0.05}>
              <p className="mt-5 text-ink-soft leading-relaxed">{p}</p>
            </Reveal>
          ))}

          <Reveal delay={0.3}>
            <div className="mt-8">
              <p className="flex items-center gap-2 text-sm font-semibold text-ink mb-3">
                <MapPin className="h-4 w-4 text-brand" /> Nous intervenons dans toute l&apos;Île-de-France
              </p>
              <div className="flex flex-wrap gap-2">
                {ZONES.map((z) => (
                  <span key={z} className="chip">{z}</span>
                ))}
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.35}>
            <a href={COMPANY.phoneHref} className="btn-primary mt-8">
              <Phone className="h-4 w-4" /> {COMPANY.phone}
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
